import Virtual_reality from "../images/postSvgs/Virtual_reality.svg"
import Conference from "../images/postSvgs/Conference.svg"
import Visionary_technology from "../images/postSvgs/Visionary_technology.svg"
import Lost_online from "../images/postSvgs/Lost_online.svg"
import Collaborator from "../images/postSvgs/Collaborator.svg"
import Book_lover from "../images/postSvgs/Book_lover.svg"

const worksData = [
  {
    title: "Book Summary",
    description:
      "How To Read A Book by Mortimer J. Adler and Charles van Doren (10 minute read)",
    link: "https://medium.com/@tuguscript/how-to-read-a-book-by-mortimer-j-adler-and-charles-van-doren-10-minute-read-bf78db7d7af2",
    image: Book_lover,
  },
  {
    title: "Oluulaa",
    description:
      "We connect professionals who truly want to share tips and help one another.",
    link: "https://www.oluulaa.io/",
    github: "https://github.com/tuguScript/oluulaa",
    image: Collaborator,
  },
  {
    title: "Mechef",
    description:
      "Mechef is an webapp that helps users to find recipes based on ingredients. That app was built with Ruby on Rails and React.",
    link: "http://mechef.ga/",
    github: "https://github.com/tuguScript/recipeFinder",
    image: Virtual_reality,
  },
  {
    title: "Cryptowise",
    description:
      "Cryptowise is connecting investors with expert level cryptoasset financial analysis. My responsibility was to work on the front-end.",
    link: "https://cryptowise.ai/",
    github: null,
    image: Conference,
  },
  {
    title: "Gitter Clone",
    description: "It's an instant messaging and chat room system.",
    link: "https://gitterclone.ga/",
    github: null,
    image: Visionary_technology,
  },
  {
    title: "Todoro",
    description:
      "Sample todo app that has been built as Progressive Web App with Offline Support. The app was built with React.js.",
    link: "https://todoro.ga/",
    github: null,
    image: Lost_online,
  },
]

export default worksData
